import m from "./_baseClamp.js";
import d from "./toNumber.js";
var t = m, a = d;
function b(i, f, n) {
  return n === void 0 && (n = f, f = void 0), n !== void 0 && (n = a(n), n = n === n ? n : 0), f !== void 0 && (f = a(f), f = f === f ? f : 0), t(a(i), f, n);
}
var _ = b;
export {
  _ as default
};
//# sourceMappingURL=clamp.js.map
